// extracted by mini-css-extract-plugin
export default {"previewImg":"AddContact_previewImg__egTSi"};